import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Note", -1)
const _hoisted_2 = {
  key: 0,
  class: "larger-width-centered"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Attachment: ")
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Remove Attachment", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = {
  class: "form-field",
  style: {"margin-top":"15px"}
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Replace ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Attachment", -1)
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("button", { class: "btn" }, "Cancel", -1)

import { useRouter } from "vue-router";
import { ref } from "vue";
import api from "@virgodev/bazaar/functions/api";

export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: Number,
    required: true,
  },
  noteId: {
    type: Number,
    required: true,
  },
  customerName: {
    type: String,
    required: true,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

const formErrors = ref<Record<string, string[]>>({});
const formSubmitting = ref(false);

const router = useRouter();
const note = ref();
const noteattach = ref();
const errors = ref("");
const fileInput = ref<HTMLInputElement | null>(null);
const removeAttachment = ref(false);

function uploadFile(e: Event) {
  const fileInput = e.target as HTMLInputElement;
  const file = (fileInput.files as FileList)[0];

  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = (e) => {
    if (e.target) {
      noteattach.value = e.target.result;
    }
  };
}
async function submitForm() {
  formErrors.value = {};
  formSubmitting.value = true;
  let body = new FormData();
  if (
    fileInput.value &&
    fileInput.value.files &&
    fileInput.value.files.length > 0
  ) {
    body.append("attachment", fileInput.value.files[0]);
  }
  body.append("body", note.value.body);
  if (
    removeAttachment.value &&
    fileInput.value &&
    fileInput.value.files &&
    fileInput.value.files.length == 0
  ) {
    body.append("remove_attachment", "true");
  }

  let url = `notes/?id=${props.noteId}&facilityId=${props.facilityId}`;

  const responseData = await api({
    url,
    method: "PATCH",
    body,
  });
  if ([200, 201].includes(responseData.status)) {
    router.push({
      name: "customer_detail_ess",
      params: {
        id: props.customerId,
        facilityId: props.facilityId,
      },
    });
  } else if (responseData.status === 400) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}

async function getNote() {
  errors.value = "";
  const response = await api({
    url: `notes/?id=${props.noteId}&single=${true}&facilityId=${
      props.facilityId
    }`,
  });
  if (response.status == 200) {
    note.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
getNote();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_RouterLink, {
      to: {
      name: 'customer_detail_ess',
      params: { id: __props.customerId, facilityId: __props.facilityId },
    }
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Customer: " + _toDisplayString(__props.customerName), 1)
      ]),
      _: 1
    }, 8, ["to"]),
    _hoisted_1,
    (note.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((note.value.body) = $event))
          }, null, 512), [
            [_vModelText, note.value.body]
          ]),
          _hoisted_3,
          (note.value.attachment && note.value.attachment.url)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_4,
                _createElementVNode("a", {
                  href: note.value.attachment.url
                }, _toDisplayString(note.value.attachment.url), 9, _hoisted_5),
                _hoisted_6,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((removeAttachment).value = $event)),
                  type: "checkbox"
                }, null, 512), [
                  [_vModelCheckbox, removeAttachment.value]
                ]),
                _hoisted_7,
                _hoisted_8
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            (note.value.attachment.url)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_10
                ], 64))
              : _createCommentVNode("", true),
            _hoisted_11,
            _createElementVNode("input", {
              ref_key: "fileInput",
              ref: fileInput,
              type: "file",
              onChange: uploadFile
            }, null, 544)
          ]),
          _createElementVNode("button", {
            class: "btn",
            disabled: formSubmitting.value,
            onClick: submitForm
          }, " Update Note ", 8, _hoisted_12),
          _createVNode(_component_RouterLink, {
            to: {
        name: 'customer_detail_ess',
        params: { id: __props.customerId, facilityId: __props.facilityId },
      }
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})